jQuery(document).ready(function($) {

  const stylesSliderSettings = {
    dots: true,
    autoplay: false,
    slidesToShow: 1,
    infinite: true,
    centerMode: true,
    centerPadding: '200px',
    arrows: false,
    mobileFirst: true,
    responsive: [{
      breakpoint: 768,
      settings: 'unslick'
    },{
      breakpoint: 550,
      settings: {
        centerPadding: '20vw',
        dots: true,
        autoplay: false,
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        arrows: false,
      }
    },{
      breakpoint: 1,
      settings: {
        centerPadding: '10.667vw',
        dots: true,
        autoplay: false,
        slidesToShow: 1,
        infinite: true,
        centerMode: true,
        arrows: false,
      }
    }]
  }

  $('.styles-slider').slick(stylesSliderSettings)


  $(window).on('resize orientationchange', function() {
    var slider = $('.styles-slider');

    if(!slider.hasClass('slick-initialized')){
         slider.slick(stylesSliderSettings);
    }
  })

})
